export default __webpack_public_path__ + "static/media/icon_app_tgs.e2b5c1e0.svg";